export default __webpack_public_path__ + "static/media/hero.1a1c9dcf.jpg";